export const environment = {
  github: 'https://github.com/shreyashrajiokalaskar',
  linkedin: 'https://www.linkedin.com/in/shreyash-kalaskar/',
  resume: 'assets/docs/Shreyash_Kalaskar_FullStack_2026.pdf',
  RE_CAPTCHA_SITE_KEY: '6LfN8kArAAAAAGvG_in_KzGDDNFqXTpYALc2pKgd',
  emailJsPublicKey: 'OXz2u2FMc6zY5Pt62',
  serviceId: 'service_m7ldp0h',
  templateId: 'template_b90w8wk',
};
